import React, { FunctionComponent } from 'react'
import { FieldRenderProps } from '@progress/kendo-react-form';
import ClientList from '../../Client/ListControls/ClientFieldList';

export const ClientField: FunctionComponent<FieldRenderProps> = props => {
    const { field, ...others } = props;

    return (
        <ClientList {...others} field={field} />
    )

}
